import React, { useMemo } from "react";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";

export default function SalesPerformanceReport() {
  const columns = useMemo(
    () => [
      { name: "Period", selector: (r) => r.Period || r.Month || "-" },
      { name: "Units", selector: (r) => r.UnitsSold ?? 0 },
      { name: "Amount", selector: (r) => r.TotalAmount ?? 0 },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="salesPerformance"
      title="Sales Performance"
      columns={columns}
      fetchConfig={{
        url: "/reports/app2/sales-performance",
        paramsBuilder: (filters) => ({
          fromDate: filters.fromDate,
          toDate: filters.toDate,
          groupBy: filters.groupBy || "month",
        }),
      }}
      initialFilters={{ groupBy: "month" }}
      renderFilters={(filters, setFilters) => (
        <div className="col-sm-12 col-md-3">
          <label className="form-label">Group By</label>
          <select
            className="form-select"
            value={filters.groupBy || "month"}
            onChange={(e) => setFilters((p) => ({ ...p, groupBy: e.target.value }))}
          >
            <option value="day">Day</option>
            <option value="month">Month</option>
            <option value="model">Model</option>
          </select>
        </div>
      )}
      buildKpis={(rows) => {
        const units = (rows || []).reduce((a, r) => a + Number(r?.UnitsSold ?? 0), 0);
        const amt = (rows || []).reduce((a, r) => a + Number(r?.TotalAmount ?? 0), 0);
        return [
          { label: "Units", value: units },
          { label: "Amount", value: amt.toLocaleString("en-IN") },
        ];
      }}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

